import { render, staticRenderFns } from "./BookUploader.vue?vue&type=template&id=fefdb3c6&scoped=true&"
import script from "./BookUploader.vue?vue&type=script&lang=js&"
export * from "./BookUploader.vue?vue&type=script&lang=js&"
import style0 from "./BookUploader.vue?vue&type=style&index=0&id=fefdb3c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fefdb3c6",
  null
  
)

export default component.exports